import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "type",
      description: "标签类型",
      type: "String",
      default: "display",
      available: "display/closeonly"
    },
    {
      prop: "theme",
      description: "标签主题",
      type: "String",
      default: "1",
      available: "display下有1-5，closeonly有1-2"
    }
  ],
  events: [
    {
      name: "close",
      description: "点击关闭Tag时触发的事件"
    }
  ],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
